export const STUFF_TO_EAT = {
  DISH: 'dish',
  DRINK: 'drink',
  MEAL: 'meal',
  FOOD_PRODUCT: 'food_product',
};

export const STUFF_TO_EAT_KEYS = {
  dish: 'dishes',
  drink: 'drinks',
  meal: 'meals',
  food_product: 'food-products',
};

export const PROGRAMS = {
  DIET: 'diet',
  WORKOUT: 'workout',
  PROGRAM: 'program',
};

export const PROGRAMS_KEYS = {
  diet: 'diets',
  workout: 'workouts',
  program: 'programs',
};

export const SCHEDULES = {
  STUFF_TO_EAT: 'stuff_to_eat',
  WORKOUTS: 'workouts',
  REMINDER: 'reminder',
  FILL_QUESTIONARY: 'fill_questionary',
  ADD_MEASUREMENT: 'add_measurement',
};

export const PERSON = {
  PARTICIPANT: 'participant',
  PROFFESIONAL: 'proffesional',
  PERSONAL: 'personal',
  TEAM_MEMBER: 'team-member',
};

export const PERSON_KEYS = {
  participant: 'participants',
  professional_leader: 'my-team',
  my_team: 'my-team',
};

export const ACTIVITY_KEYS = {
  basic_activity: 'basic-activities',
  exercise: 'exercises',
  training: 'trainings',
};

export const LOCAL_STORAGE_KEYS = {
  invitations_list: 'invitations_list',
  my_team_list: 'my_team_list',
  sys_admin_instances_list: 'sys_admin_instances_list',
};

export const SETTINGS_PRESETS_KEYS = {
  allergens: 'allergens',
};



// WEBPACK FOOTER //
// ./src/constants/types.js